// Single source of truth for all calculators.
// Used by the Navbar, the Home page grid, and the footer.
// When adding a calculator: add its entry here, add the <Route> in App.js,
// and add the URL to public/sitemap.xml.
export const CALCULATORS = [
  {
    path: "/pakistan-income-tax",
    name: "Pakistan Income Tax Calculator 2026-27",
    short: "PK Tax",
    icon: "🇵🇰",
    description: "Estimate your salaried income tax and take-home pay under the latest FBR slabs.",
  },
  {
    path: "/zakat",
    name: "Zakat Calculator",
    short: "Zakat",
    icon: "🕌",
    description: "Work out your Zakat (2.5%) and check whether your wealth meets the nisab.",
  },
  {
    path: "/age",
    name: "Age Calculator",
    short: "Age",
    icon: "🎂",
    description: "Find your exact age in years, months, and days from your date of birth.",
  },
  {
    path: "/bmi",
    name: "BMI Calculator",
    short: "BMI",
    icon: "⚖️",
    description: "Check your Body Mass Index and see which weight category you fall into.",
  },
  {
    path: "/loan",
    name: "Loan EMI Calculator",
    short: "Loan EMI",
    icon: "🏦",
    description: "Work out your monthly loan installment from amount, rate, and tenure.",
  },
  {
    path: "/compound-interest",
    name: "Compound Interest Calculator",
    short: "Interest",
    icon: "📈",
    description: "See how your savings or investments grow with compound interest.",
  },
  {
    path: "/percentage",
    name: "Percentage Calculator",
    short: "Percentage",
    icon: "％",
    description: "Percent of a number, percentage change, and \"X is what % of Y\".",
  },
  {
    path: "/discount",
    name: "Discount Calculator",
    short: "Discount",
    icon: "🏷️",
    description: "Find the final price and how much you save after a discount.",
  },
  {
    path: "/tip",
    name: "Tip Calculator",
    short: "Tip",
    icon: "🍽️",
    description: "Calculate the tip and total bill, with an optional per-person split.",
  },
  {
    path: "/currency",
    name: "Currency Converter",
    short: "Currency",
    icon: "💱",
    description: "Convert between currencies using an exchange rate you provide.",
  },
  {
    path: "/unit-converter",
    name: "Unit Converter",
    short: "Units",
    icon: "📏",
    description: "Convert length, weight, and temperature units instantly.",
  },
  {
    path: "/days-between",
    name: "Days Between Dates",
    short: "Days",
    icon: "📅",
    description: "Count the number of days between any two dates.",
  },
];
